import { useEffect } from 'react';

export default function PageMeta({ title, description }) {
  useEffect(() => {
    if (title) document.title = `${title} · Valanti Labs`;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement('meta');
        m.setAttribute('name', 'description');
        document.head.appendChild(m);
      }
      m.setAttribute('content', description);
    }
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [title, description]);
  return null;
}
